import script from "./BreakScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./BreakScreen.vue?vue&type=script&setup=true&lang=js"

import "./BreakScreen.vue?vue&type=style&index=0&id=e9d78ae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d78ae0"]])

export default __exports__